// extracted by mini-css-extract-plugin
export default {"heading":"Ox-z","corrected":"Px-z","redirectVerbiageContainer":"Qx-z","redirectVerbiageText":"Rx-z"};